import { useEffect } from "react";

const setLd = (id, data) => {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const useSEO = ({ title, description, jsonLd, canonical }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    if (canonical) {
      let l = document.querySelector('link[rel="canonical"]');
      if (!l) {
        l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        document.head.appendChild(l);
      }
      l.setAttribute("href", canonical);
    }
    setLd("ld-page", jsonLd);
    window.scrollTo(0, 0);
    return () => setLd("ld-page", null);
  }, [title, description, jsonLd, canonical]);
  return null;
};
